import { env } from '$env/dynamic/public';
import { HttpError } from '$lib/HttpError';
import type { Launch } from '$lib/types/public-resources/launches/launch';

export class LaunchesApiClient {
  fetch: (input: RequestInfo | URL, init?: RequestInit) => Promise<Response>;

  constructor(fetch: (input: RequestInfo | URL, init?: RequestInit) => Promise<Response>) {
    this.fetch = fetch;
  }

  async getLaunch(idLaunch: string): Promise<Launch> {
    const res = await this.fetch(
      `${env.PUBLIC_LAUNCH_SERVICE_BASE_URL}public-resources/v1/launches/${idLaunch}`
    );

    if (!res.ok) {
      throw new HttpError(res.status);
    }

    return await res.json();
  }
}
